import { useEffect, useState } from "react";
import { Button, Field } from "../components/rumonai";
import type { AgentInstance } from "./api";
import { clientErrorText, hub } from "./api";
import { clientName, useLocalClients } from "./LocalClients";

export function LocalDevice({ agent, onUpdated }: { agent: AgentInstance; onUpdated?: (agent: AgentInstance) => void }) {
  const directory = useLocalClients();
  if (agent.location !== "local") return null;
  if (!agent.client_id && !agent.paired && !agent.online && !agent.device && typeof agent.last_connected_at !== "number")
    return <UnpairedAgentClient key={agent.id} agent={agent} onUpdated={onUpdated} />;
  if (!agent.client_id) return <div className="local-connected-summary">
    <p>接入客户端，继续使用这个已有 Agent。</p><a className="btn btn-quiet" href="/#/clients">我的电脑</a>
  </div>;
  const client = (!directory.error ? directory.clients?.find(item => item.id === agent.client_id) : null) || agent.client;
  return <div className="local-client-location">
    <div className="local-connected-summary"><p>电脑：<a href={"/#/clients?client=" + encodeURIComponent(agent.client_id)}
      data-quoted="true">{client ? clientName(client, directory.clients || []) : "电脑信息待更新"}</a></p>
      <span className="local-connect-state">{client ? client.online ? "客户端在线" : "客户端离线" : "状态待更新"}</span></div>
  </div>;
}

function UnpairedAgentClient({ agent, onUpdated }: { agent: AgentInstance; onUpdated?: (agent: AgentInstance) => void }) {
  const directory = useLocalClients();
  const [clientId, setClientId] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    if (!clientId && directory.clients?.length === 1) setClientId(directory.clients[0].id);
  }, [clientId, directory.clients]);
  const selected = directory.clients?.find(client => client.id === clientId);
  const bind = async (event: React.FormEvent) => {
    event.preventDefault();
    if (busy || !selected || directory.error) return;
    setBusy(true); setError(null);
    try {
      const result = await hub.bindClient(agent.id, selected.id);
      onUpdated?.(result.agent);
    } catch (failure) { setError(failure); directory.refresh(); }
    finally { setBusy(false); }
  };
  if (!directory.clients?.length) return <div className="local-connected-summary">
    <p>{directory.clients === null && !directory.error ? "正在读取我的电脑…" : "先连接你的电脑"}</p>
    <a className="btn btn-quiet" href="/#/clients">我的电脑</a>
  </div>;
  return <form className="local-client-bind" onSubmit={bind} aria-busy={busy}>
    <Field label="使用哪台电脑">
      <select className="text-input" aria-label="已有 Agent 的客户端" value={clientId} onChange={event => setClientId(event.target.value)} disabled={busy}>
        <option value="">选择电脑</option>{directory.clients.map(client => <option key={client.id} value={client.id}>
          {clientName(client, directory.clients || [])}{client.online ? " · 在线" : " · 离线"}</option>)}
      </select>
    </Field>
    <Button type="submit" variant="secondary" disabled={busy || !selected || Boolean(directory.error)}>{busy ? "正在确认…" : "确认使用"}</Button>
    {error ? <p role="alert">{clientErrorText(error)}</p> : null}
    {directory.error ? <div className="settings-actions"><span role="alert">电脑列表暂未更新。</span>
      <Button variant="secondary" onClick={directory.refresh}>重试</Button></div> : null}
  </form>;
}
